import iView from 'iview'
import {getUserList, getUserZhxx} from '@/static/js/api/user/index'
import StoreSaveData from '@/static/js/storeSaveData'

export default {
    state: {
        info: {},
        zhinfo: {},
        loading: true
    },
    mutations: {
        userinfoAdd(state, obj) {
            state.info = obj;
        },
        userinfoZhinfo(state, obj) {
            state.zhinfo = obj;
        },
        userBarLoading(state, b) {
            state.loading = b;
        }
    },
    actions: {
        updateUserInfo({commit, state}) {
            let page = 0;
            let count = 10;
            let name = null;
            let dwzh = StoreSaveData('loginInfo').dwzh;
            let code = StoreSaveData('loginInfo').idNum;
            let grzhzt = null;
            state.loading = true;
            // 获取用户基本信息
            getUserList({
                dwzh,
                page,
                count,
                name,
                code,
                grzhzt
            }).then(res => {
                if (res.code === '0000000') {
                    let data = JSON.parse(res.body);
                    commit('userinfoAdd', data.result[0]);
                    getZhxx(data.result[0].grzh);
                } else if (res.code === '9999999') {
                    console.error(res);
                    iView.$Notice.error({
                        title: "系统错误"
                    });
                } else {
                    iView.$Notice.error({
                        title: res.message
                    });
                }
                state.loading = false;
            }).catch(err => {
                console.error(err);
                state.loading = false;
            });

            // 获取用户账户信息
            function getZhxx(grzh) {
                let form = {
                    dwzh,
                    grzh: grzh
                };
                getUserZhxx(form).then(res => {
                    if (res.code === '0000000') {
                        if (res.body) {
                            let body = res.body;
                            if (typeof(body) === 'string') {
                                let data = JSON.parse(body).result;
                                if (data.length > 0) {
                                    commit('userinfoZhinfo', data[0]);
                                }
                            }
                        }
                    }
                    state.loading = false;
                }).catch(error => {
                    state.loading = false;
                })
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/userinfo.js